<div class="left-card-container" (transitionend)="transitionEndHandler($event)" #cardContainer>
  <ng-content></ng-content>
</div>

<div (click)="onBackdropClick()" class="left-card-backdrop"></div>
